import { useCallback, useEffect, useRef, useState } from "react";

import { isInteger } from "formik";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import { useParams } from "react-router";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";
import { confirmDialog } from "primereact/confirmdialog";

const initialState = {
    id: null,
    metros: ""
}

export default function ImportacoesDados() {
    const [data, setData] = useState([]);
    const [errors, setErrors] = useState([]);
    const [form, setForm] = useState({...initialState});
    const [filteredData, setFilteredData] = useState([]);
    const [date, setDate] = useState('');
    const [metragem, setMetragem] = useState(0);

    const [isErrorsVisible, setIsErrorsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    let params = useParams();
    const toast = useRef(null);

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        api.get(`dados/importacao/list/${params.importId}`).then((response) => {
            const producoes = response.data.producoes;

            setData(producoes);
            setFilteredData(producoes);
            setDate(response.data.data);

            api.get('estoque/baixa-erros', {
                params: {
                    data: response.data.importacao.data
                }
            }).then(response => {
                setErrors(response.data);
            }).catch(error => {
                setErrors([]);
            });

            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            toast.current.show({
                severity: 'error',
                summary: 'Ocorreu um Erro',
                detail: error.response ? error.response.data.message : error.message
            });
        });

        
    }, [params.importId]);

    useEffect(() => {
        setIsLoading(true);
        if (isInteger(params.importId)) {
            fetchData();
        }
    }, [fetchData, params.importId]);

    const handleEdit = (rowData) => {
        setForm({ "id": rowData.id, metros: "" });
        setIsVisible(true);
    }

    const handleDelete = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger",
            acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary",
            rejectLabel: "Cancelar",
            header: "Excluir Produção",
            message: "Você tem certeza que deseja excluir esse registro?",
            accept: () => {
                api.delete(`dados/excluir-producao/${rowData.id}`).then(response => {
                    fetchData();
                    showSuccess(response);
                }).catch(error => {
                    showError(error);
                });
            }
        });
    }
    
    const handleSubmit = () => {
        setIsLoading(true);
        api.post(`dados/corrigir-metros/${form.id}`, form).then(response => {
            fetchData();
            setForm({...initialState});
            setIsVisible(false);
            setIsLoading(false);
            showSuccess(response);
        }).catch(error => {
            setIsLoading(false);
            showError(error);
        });
    }

    const onHide = () => {
        setForm({...initialState});
        setIsVisible(false);
    }

    useEffect(() => {
        let metragem = 0;
        filteredData.forEach(element => {
            metragem += parseFloat(element.metros);
        });

        setMetragem(metragem);
    }, [filteredData])

    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                header={() => (
                    <div className="p-mt-3 p-ml-3">
                        <h2 className="p-m-0">Dados</h2>
                        <h3 className="p-m-0">Importação da Data: {date}</h3>
                        <h3 className="p-m-0">Metragem: {Intl.NumberFormat('pt-BR').format(metragem)}</h3>
                        <small>Aplique qualquer um dos filtros para o cálculo de metragem sofrer alterações...</small>
                        {errors.length > 0 && (
                            <div>
                                <Button 
                                    className="p-button-danger p-m-1"
                                    label="Erros"
                                    onClick={() => {
                                        setIsErrorsVisible(true);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}
                className="p-m-3"
            >
                <Dialog
                    className="p-m-1"
                    footer={() => (
                        <div>
                            <Button 
                                className="p-button-secondary"
                                label="Cancelar"
                                onClick={onHide}
                            />

                            <Button 
                                className="p-button-success"
                                label="Salvar"
                                onClick={handleSubmit}
                            />
                        </div>
                    )}
                    header="Editar Registro"
                    onHide={onHide}
                    visible={isVisible}
                >
                    <div className="p-fluid">
                        <div className="p-field">
                            <label htmlFor="id">ID do Registro: </label>
                            <InputText 
                                readOnly
                                value={form.id}
                            />
                        </div>
                        <div className="p-field">
                            <label htmlFor="metros">Metros: </label>
                            <InputText 
                                onChange={e => setForm({...form, metros: e.target.value })}
                                placeholder="Exemplo: 234,40"
                                type="number"
                                value={form.metros}
                            />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    header={() => (
                        <div>
                            <Button 
                                className="p-button-secondary"
                                label="Cancelar"
                                onClick={() => { setIsErrorsVisible(false); }}
                            />
                        </div>
                    )}
                    onHide={() => { setIsErrorsVisible(false); }}
                    visible={isErrorsVisible}
                >
                    <ul>
                        {errors.map((error, index) => (
                            <>
                                {error.values.map((msg, index) => (
                                    <li key={`li${index}`}>{msg}</li>
                                ))}
                            </>
                        ))}
                    </ul>
                </Dialog>

                <DataTable
                    filterDisplay="row"
                    onValueChange={filteredData => setFilteredData(filteredData)}
                    sortField="tear"
                    responsiveLayout="scroll"
                    value={data}
                >
                    <Column sortable filter header="Tear" field="tear" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable filter header="Turma" field="turma" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable filter header="Grupo" field="grupo" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable filter header="Artigo" field="artigo" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable filter header="Rolo" field="rolo" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable filter header="Rolada" field="rolada" style={{ width: '10%', minWidth: '200px' }} />
                    <Column sortable header="Eficiência" field="eficiencia_tear" />
                    <Column sortable header="Eficiência Tecelão" field="eficiencia_tec" />
                    <Column sortable header="(m)" field="metros" />
                    <Column sortable header="rpm" field="rpm" />
                    <Column sortable header="Passadas" field="batidas" />
                    <Column header="Ações" body={(rowData) => {
                        if(parseInt(rowData.metros) === 999) {
                            return (
                                <Button
                                    className="p-button-primary"
                                    icon="pi pi-pencil"
                                    onClick={() => handleEdit(rowData)}
                                />
                            )
                        }
                        return (
                            <Button 
                                className="p-button-danger"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                            />
                        )
                    }} />
                </DataTable>
            </Card>
        </div>
    )
}